import { fromJS } from 'immutable';
import { playlist } from 'signoxe/api/schema';
import { assetFromId } from './assets';
import { optionalToJS } from './utils';



export const playlistFromId = (state, id) => {
  if (state.playlistsV2.ids.includes(id)) {
    return state.entities.getIn(['playlistsV2', id.toString()]);
  }
};
export const playlistsFromIds = (state, ids) => ids.map(id => playlistFromId(state, id));

export const playlistsAll = (state) => playlistsFromIds(state, state.playlistsV2.ids);

export const getPlaylistV2 = (state, id) => optionalToJS(playlistFromId(state, id));

export const getPlaylistsV2 = (state) => playlistsAll(state).toJS();

export const getPlaylistPreloadStateV2 = (state) => state.paginationState.playlistPageV2.nextState;
export const isFetchingPlaylistV2 = (state) => state.playlistsV2.isFetching;


// search logic

const ptags = (state) =>
  state.ptags
    .toList()
    .sortBy((tag) => tag.get("count"))
    .reverse();

export const selectedTags = (state) =>
  ptags(state)
    .filter((tag) => tag.get("selected"))
    .map((tag) => tag.get("name"));

export const getTagsV2 = (state) => tags(state).toJS();

const playlistHasTags = (playlist, tags) => {
  return tags.isSubset(playlist.get("maintags", []));
};
const playlistMatchesQuery = (playlist, query) =>
  playlist.get("name").toLowerCase().includes(query) ||
  playlist.get("maintags", []).includes(query);


const playlistFilterFunction = (query, tags) => (playlist) =>
  playlistMatchesQuery(playlist, query) &&
  playlistHasTags(playlist, tags);

const filteredPlaylistsByQuery = (state, query) => {
  let filteredPlaylists = playlistsAll(state);
  query = query.trim().toLowerCase();
  const tags = selectedTags(state);


  if (query !== "" || tags.size > 0) {
    filteredPlaylists = filteredPlaylists.filter(
      playlistFilterFunction(query, tags)
    );
  }

  return filteredPlaylists;
};
const filteredPlaylists = (state, query) => {
  return filteredPlaylistsByQuery(state, query);
};
export const getFilteredPlaylistsV2 = (state, query) => filteredPlaylists(state, query).toJS();





// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/selectors/playlistsV2.js